import React from "react";
import PropTypes from "prop-types";
import { useStoryNavigation } from "../utils/reel-navigation-context";

import ReelsOverlay from "../reel-overlay/reel-overlay";

import styles from "./with-story-renderer.module.scss";

const withStoryRenderer = (Component) => {
  const WithStoryRendererWrapper = ({ story, config, ...rest }) => {
    const mediaRef = React.useRef(null);
    const { isStoryLoading, setIsStoryLoading, storiesLength, storyIndex } =
      useStoryNavigation();

    const isVideoStory =
      story?.fields?.media?.sys?.contentType?.sys?.id === "video";
    const { cta, watchAgainText, ...storyRest } = story;

    const onVideoStartedPlaying = () => {
      setTimeout(() => {
        setIsStoryLoading(false);
        rest.action("play", true);
      }, 100);
    };

    const playVideo = async () => {
      if (!mediaRef?.current) return;

      try {
        rest.action("pause", true);
        setIsStoryLoading(true);
        await mediaRef?.current?.play();
        onVideoStartedPlaying();
      } catch (e) {
        console.log("Feature reels | Error loading FR video", {
          storyIndex,
          story,
          e,
        });
        await mediaRef?.current?.play();
        onVideoStartedPlaying();
      }
    };

    // Once watch again is present if a user press navigation back story.url won't change
    // That is why we need this effect
    // This is not working consistently in Safari
    // React.useEffect(() => {
    //   if (!hasPresentedAllStories && isVideoStory) {
    //     playVideo();
    //   }
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [hasPresentedAllStories]);

    React.useEffect(() => {
      // will call play video each a video slide appears
      if (isVideoStory) playVideo();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [story.url]);

    return (
      <div
        aria-label={`Slide ${storyIndex + 1} of ${storiesLength}`}
        data-testid="slide-accessible-group"
        role="group"
      >
        {config.header && !isStoryLoading && (
          <h3 className={styles.reelHeader}>{config.header}</h3>
        )}
        <Component
          config={config}
          ref={mediaRef}
          story={storyRest}
          setIsMediaLoading={setIsStoryLoading}
          storiesLength={storiesLength}
          storyIndex={storyIndex}
          {...rest}
        />
        <ReelsOverlay
          ctaData={cta}
          dispatchInstaStoryAction={rest.action}
          isMediaLoading={isStoryLoading}
          storyType={story.type}
          videoRef={mediaRef}
          watchAgainText={watchAgainText}
        />
      </div>
    );
  };

  WithStoryRendererWrapper.propTypes = {
    story: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired,
    action: PropTypes.func.isRequired,
  };

  return WithStoryRendererWrapper;
};

export default withStoryRenderer;
